import Vue from 'vue'
import _ from "lodash";

import Service from "./../../Libs/Service";

let Notifications = new Service({

	Name: "Notifications",

	Events: {},

	init() {

		this.wrapperClass = 'notifications-wrapper';
		this.commonSettings = {
			position: 'bottom right',
			max: 3,
			duration: 5000
		};

	},

	showError(text, options = {}) {

		Vue.prototype.$notify(_.assign({}, this.commonSettings, {
			group: this.wrapperClass,
			type: 'error',
			title: 'Error',
			text
		}, options));

	},

	showSuccess(text, options = {}) {

		Vue.prototype.$notify(_.assign({}, this.commonSettings, {
			group: this.wrapperClass,
			type: 'success',
			title: 'Success',
			text
		}, options));

	}

});

window.Notifications = Notifications;

export { Notifications }

